"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const remove_svg_1 = __importDefault(require("./assets/remove.svg"));
const TypeaheadResultContainer = styled_components_1.default.span `
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 16px;
  text-align: left;
  padding: 8px 12px;
  background-color: rgba(0, 50, 100, 0);
  transition: 150ms ease;

  ${({ selected }) => selected && ` font-weight: 800; `}

  &:hover {
    background-color: rgba(0, 50, 100, 0.08);
    ${({ selected }) => selected && `background-color: rgba(100, 0, 50, 0.08);`}
  }
`;
const TypeaheadResult = ({ item: { label }, selected }) => (react_1.default.createElement(TypeaheadResultContainer, { selected: selected },
    label,
    selected && (react_1.default.createElement("img", { src: remove_svg_1.default, style: { flexShrink: 0 }, alt: "Remove item" }))));
exports.default = TypeaheadResult;
//# sourceMappingURL=TypeaheadResult.js.map